import React from 'react';
import { StopCircle, User, Calendar } from 'feather-icons-react/build/IconComponents';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { selectCustomerData } from '../../core/redux/customer/selectors';
import { selectStatuses } from '../../core/redux/status/selectors';
import { selectProcessStatuses } from '../../core/redux/status/selectors';
import { selectInspectionPlanFilters } from './store/selectors';
import { actions as inspectionPlanActions, fetchInspectionPlansWithFilters } from './store/slice';
import { Link } from 'react-router-dom';
import { useTransformOptions } from 'Core/hooks';

const { setCustomer, setStatus, setStartDate, setEndDate } = inspectionPlanActions;

const InspectionPlanFilter = () => {
  const dispatch = useDispatch();
  const customers = useSelector(selectCustomerData);
  // const statuses = useSelector(selectStatuses);
  // const {
  //   type: selectedType,
  //   startDate,
  //   endDate,
  // } = useSelector(selectInspectionPlanFilters);

   
   const statuses = useSelector(selectProcessStatuses);
   const {
     status: selectedStatus,
   } = useSelector(selectInspectionPlanFilters);
 
   const customerOptions = useTransformOptions(
     customers,
     'id',
     'customerName',
     '0',
     'Select Customer',
   );
   const statusOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');
 
   const handleStatusChange = selected => {
     dispatch(setStatus(selected));
   };

  const onSearch = () => {
    dispatch(fetchInspectionPlansWithFilters());
  };

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
          <div className="col-lg-4 col-sm-6 col-12">
              <div className="input-blocks">
                <StopCircle className="info-img" />
                <Select
                  className="img-select"
                  options={statusOptions}
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  classNamePrefix="react-select"
                  placeholder="Choose Status"
                />
              </div>
            </div>

          <div className="col-lg-4 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <Link className="btn btn-filters ms-auto" onClick={onSearch}>
                {' '}
                <i data-feather="search" className="feather-search" /> Search{' '}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InspectionPlanFilter;
